<template>
  <div class="regPage">
   <el-form :model="regInfo" class="regForm" label-width="100px">
        <el-form-item class="infoInput" prop="userName" label="邮箱地址">
          <el-input v-if="!regInfo.userNameStatus" v-model="regInfo.userName" class="emailAddr" readonly="true" maxlength="25">
          </el-input>
          <el-select v-if="regInfo.userNameStatus" v-model="regInfo.userName" placeholder="请选择">
            <el-option
              v-for="(item,key) in regInfo.userNames"
              :key="key"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          <span class="emailName">@tongji.edu.cn</span>
        </el-form-item>


         <el-form-item class="infoInput" prop="xgh" label="别名" >
           <el-input v-model="regInfo.xgh" readonly="true" maxlength="25"></el-input>
            <p class="tips"></p>
        </el-form-item>
         
        <div class="infoBtn" >
            <el-button type="primary" @click="regEmail()">绑定</el-button>
            <el-button type="primary" @click="escRegEmail()">取消</el-button>
        </div>

    </el-form>
    <!-- 消息提示栏 -->
    <el-dialog
      :visible.sync="successInfo"
      custom-class="showBox"
      width="467px"
      :close-on-click-modal="boxCloseInfo"
      :close-on-press-escape="boxCloseInfo"
      :show-close="boxCloseInfo"
      center>
      <span class="boxTitle">亲爱的校友:</span>
      <p class="boxBody">恭喜您! <span class="emilName">{{regInfo.xgh}}@tongji.edu.cn  </span>已经添加到别名</p>
      <span slot="footer" class="dialog-footer">
        <a href="https://mail.tongji.edu.cn" class="boxBtn" type="primary">开始使用</a>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  const PwdPatrn = (str) => {
    const reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/;
    return reg.exec(str);
}

		
export default {
  name: "regForm",
  props: ['userInfo'],
  data() {
    return {
        successInfo:false,
        boxCloseInfo:false,
        userPrincipalName: '',
        errorMsg:"",
        regInfo: {
          xgh:'',
          userName:'',
          userNames:'',
          userNameStatus:false
        },


    };
  },

  methods: {

      //注册
      regEmail(){
        let self = this;
        const regEmailStatus = JSON.parse(localStorage.getItem("regEmailStatus"));
        const url = "/email/addCoremail?xgh="+self.regInfo.userName +"&nickName="+self.regInfo.xgh +"&token="+self.md5(regEmailStatus.token)
            self.postRequest(url, {}).then(result => {
            if(result.data && result.data.msgStatus==0){
               self.$alert("绑定失败，请重新验证身份", "错误提示", {
                confirmButtonText: "确定",
                type: "error",
                center: true,
                customClass: "errMessage",
                callback: action => {
                  self.$router.push({ name: 'Home'})
                }
              });
            }else if(result.data && result.data.msgStatus==1){
              self.successInfo = true
            }else{
              self.$router.push({ name: 'Home'})
              self.$alert("认证身份信息已过期，请重新验证", "错误提示", {
                confirmButtonText: "确定",
                type: "error",
                center: true,
                customClass: "errMessage",
                callback: action => {
                  self.$router.push({ name: 'Home'})
                }
              });
            }
          
          })
      },
      escRegEmail(){
        const self = this ;
        self.$confirm("取消绑定邮箱操作？", "提示", {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning',
          center: true,
          customClass: "errMessage",
          }).then(() => {
          self.$router.push({ name: 'Home'})
        }).catch(() => {
              
        });   
      }

  },
  mounted() {
    
    const self = this;
    const regEmailStatus = JSON.parse(localStorage.getItem("regEmailStatus"));
    if (regEmailStatus && regEmailStatus.uid && regEmailStatus.token) {

          self.regInfo.xgh = regEmailStatus.uid;

          const userName = regEmailStatus.userName;       
          let _userName = new Array();
          if(userName.indexOf(',')!= -1){
            _userName = userName.split(',')
            self.regInfo.userNameStatus = true
            self.regInfo.userName  = _userName[0]
            self.regInfo.userNames  = _userName
          }else{
            self.regInfo.userNameStatus = false
             self.regInfo.userName  = userName
          }
      
}else{
        //   self.$router.push({ name: 'Home'})
        // self.$alert("认证身份信息已过期，请重新验证", "错误提示", {
        //   confirmButtonText: "确定",
        //   type: "error",
        //   center: true,
        //   customClass: "errMessage",
        //   callback: action => {
        //     self.$router.push({ name: 'Home'})
        //   }
        // });
}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.emilName{
  color: #eb5468;
  font-size: 20px;
}
.emailAddr{
  width: 230px;
}
.emailName{
    display: inline-block;
    border: 1px solid #dcdfe6;
    width: 135px;
    text-align: center;
    margin-left: -12px;
    line-height: 38px;
  }
.infoInput {
  width: 460px;
  height: 41px;
  margin: 0 auto;
  margin-top: 30px;
}
.tips{
  width: 370px;
    padding: 0;
    line-height: 25px;
    color: #999;
    font-size: 12px;
}
  .infoBtn{
    margin: 0 auto;
    margin-top: 60px;
    text-align: center;
    width: 505px;
  }
    .infoBtn button:nth-of-type(1){
      margin-right: 35px;
    }
  .infoBtn button{
    width: 130px;
  }
 .showBox .boxTitle{
     display: block;
     font-size: 20px;
     color: #778085;
     margin-left: 31px;
  }
  .showBox .boxBody{
     font-size: 16px;
     color: #778085;
     padding: 0 31px;
     word-break:break-all; 
  }
  .showBox .boxBtn{
    display: block;
    width: 395px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    margin-bottom: 30px;
    background: #198bfd;
    color: #fff;
  }
.showBox .boxBtn:hover{
  background: #66b1ff;
}
</style>



// WEBPACK FOOTER //
// src/page/Coremail/bind/form.vue